(function( $ ) {
    'use strict';

    $(function() {
        var getDisplay = function( value, type ) {
                return type === 'percentage' ? value + '%' : value;
            },
            getValue = function( value, type ) {
                return type === 'percentage' ? value / 100 : value;
            },
            setValue = function( value, type ) {
                return type === 'percentage' ? value * 100 : value;
            },
            sliderInit = function( $slider ) {
                // Get handle and hidden
                var $handle = $('#' + $slider.data('name') + '-slider__handle'),
                    $value = $('#' + $slider.data('name'));

                //noinspection JSUnusedGlobalSymbols
                $slider.slider({
                    value: setValue($value.val(), $handle.data('type')),
                    min: 1,
                    max: 99,
                    step: 1,
                    create: function() {
                        $handle.text(getDisplay($slider.slider('value'), $handle.data('type')));
                        $value.val(getValue($slider.slider('value'), $handle.data('type')));
                    },
                    slide: function( event, ui ) {
                        $handle.text(getDisplay(ui.value, $(ui.handle).data('type')));
                        $value.val(getValue(ui.value, $(ui.handle).data('type')));
                    }
                });
            };

        // Create sliders
        $('.supasearch-slider').each(function( i, el ) {
            sliderInit($(el));
        });
    });

})(jQuery);
(function( $ ) {
    'use strict';

    $(function() {
        var $button = $('#supasearch_db_sync'),
            $progress = $('#supasearch_db_sync_progress'),
            $progressBar = $('#supasearch_db_sync_progress_bar'),
            $progressBarFill = $('#supasearch_db_sync_progress_bar_fill'),
            progressMessage = 'DO NOT LEAVE PAGE. Database content sync in progress...',
            unexpectedError = 'An unexpected error occurred!',
            syncInProgress = false,
            updateProgress = function( message, percentage ) {
                // Update Text
                $progress.html(message || '');

                // Update progress bar with passed percentage
                if( typeof percentage === 'undefined' ) {
                    $progressBar.hide().attr('data-progress', '0%');
                    $progressBarFill.width('0%');
                } else {
                    $progressBar.show().attr('data-progress', percentage + '%');
                    $progressBarFill.width(percentage + '%');
                }
            },
            callDbSync = function( offset ) {
                $.ajax({
                    url: '/wp-admin/admin-ajax.php?action=supasearch_db_content_sync',
                    data: {
                        "supasearch_sync_offset": offset
                    },
                    success: function( response ) {
                        if( typeof response.status !== 'undefined' && response.status === 'success' ) {
                            /** @property {int} response.progress.percentage */
                            /** @property {int} response.progress.offset */

                            // If progress percentage is less then 100% then recursively call sync with new offset
                            if( response.progress.percentage < 100 ) {
                                // Update progress
                                updateProgress(progressMessage, response.progress.percentage);
                                // Call sync with new offset
                                callDbSync(response.progress.offset);
                            } else {
                                // Update process to show sync is complete
                                updateProgress('Database content sync complete.', response.progress.percentage);
                                // Sync complete so set in progress flag to false
                                syncInProgress = false;
                            }
                        } else {
                            // Update text to alert user that an error occurred
                            updateProgress(unexpectedError);
                            // Sync returned an error and stopped so set in progress flag to false
                            syncInProgress = false;
                        }
                    },
                    error: function( response ) {
                        // Set error message
                        var errorMessage = response.responseText ? response.responseText : response.statusText ? response.statusText : unexpectedError;
                        // Update text to alert user that an error occurred
                        updateProgress(errorMessage);
                        // Sync returned an error and stopped so set in progress flag to false
                        syncInProgress = false;
                    }
                });
            };

        $button.on('click', function() {
            // Return if in progress
            if( syncInProgress === false ) {
                // Set in progress flag
                syncInProgress = true;
                // Update progress message and bar
                updateProgress(progressMessage, 0);
                // Start sync
                callDbSync(0);
            }
        });
    });

})(jQuery);